import * as React from 'react';
import {FunctionComponent} from 'react';

export interface ButtonProps {
    children?: any;
    className?: string | undefined;
    onClick?: () => void;
    title?: string;
    disabled?: boolean;
}

export const Button: FunctionComponent<ButtonProps> = ({title, disabled, className, onClick, children}) => <button
    className={'btn ' + className}
    title={title}
    disabled={disabled}
    onClick={onClick}>
    {children}
</button>;
